export default "__VITE_ASSET__C8k368$V__"